import { render, staticRenderFns } from "./FormCreateForm.vue?vue&type=template&id=658a00b9"
import script from "./FormCreateForm.vue?vue&type=script&lang=js"
export * from "./FormCreateForm.vue?vue&type=script&lang=js"
import style0 from "./FormCreateForm.vue?vue&type=style&index=0&id=658a00b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports